import React, { Component } from "react";
import _ from "lodash";
import { Box } from "reflexbox";
import {
  CommandBarButton,
  PrimaryButton
} from "office-ui-fabric-react/lib/Button";
import { Modal } from "office-ui-fabric-react/lib/Modal";

class Manifest extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false
    };
  }

  _showModal = () => {
    this.setState({ showModal: true });
  };

  _closeModal = () => {
    this.setState({ showModal: false });
  };

  _printDiv = () => {
    var printContents = document.getElementById("printable").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    this._closeModal();
    window.location.replace("/");
    // document.body.innerHTML = originalContents;
  };

  render() {
    const { date } = this.props.shipment;
    const plate =
      this.props.shipment.carrierByCarrierId.truck +
      "-" +
      this.props.shipment.carrierByCarrierId.trailer;
    const { driver1Tel, driver2Tel } = this.props.shipment.carrierByCarrierId;
    const data = this.props.selectedItems;

    return (
      <div>
        <CommandBarButton
          styles={{ root: { padding: "10px" } }}
          title="Manifest"
          iconProps={{ iconName: "PDF" }}
          onClick={this._showModal}
          text="Manifest"
        />
        <Modal
          isOpen={this.state.showModal}
          onDismiss={this._closeModal}
          isBlocking={false}
          containerClassName="ms-modalExample-container"
        >
          <Box p={2} style={{ width: "80vw", height: "80vh" }}>
            <div>
              <PrimaryButton text="Print" onClick={this._printDiv} />
              <PrimaryButton
                style={{ marginLeft: "5px" }}
                text="Close"
                onClick={this._closeModal}
              />
            </div>
            <Box id="printable">
              <h4>Дата загрузки: {date}</h4>
              <h4>Манифест трака: {plate}</h4>
              <table>
                <thead>
                  <tr>
                    <td>Seller</td>
                    <td>Packing Code</td>
                    <td>Boxes</td>
                    <td>Brutto</td>
                    <td>Airwaybill</td>
                    <td>Cargo type</td>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    _.map(data, (order, key) => (
                      <tr key={key}>
                        <td>
                          {order.relationBySellerId &&
                            order.relationBySellerId.code}
                        </td>
                        <td>{order.packingCode && order.packingCode}</td>
                        <td>{order.boxes}</td>
                        <td>{order.brutto}</td>
                        <td>{order.awb}</td>
                        <td>
                          {order.cargoTypeByCargoTypeId &&
                            order.cargoTypeByCargoTypeId.type}
                        </td>
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td>{`Boxes: ${_.sumBy(data, "boxes")}`}</td>
                    <td>{`Brutto: ${_.sumBy(data, "brutto")}`}</td>
                    <td>{`Pallets: ${_.sumBy(data, "amountPallets").toFixed(
                      2
                    )}`}</td>
                  </tr>
                </tfoot>
              </table>
            </Box>
          </Box>
        </Modal>
      </div>
    );
  }
}

export default Manifest;



// WEBPACK FOOTER //
// ./src/views/Reports/Manifest.js